import Button from "@/components/button";
import Input from "@/components/input";
import Categorized from "@/components/categorized";
import ExtLink from "@/components/ext-link";
import Info from "@/components/info";
import RestoreBtn from "@/components/restore-btn";
import SetStatus from "@/containers/set-status";
import {mapGetters} from "vuex";
import axios from "@/axios";

export default {
    name: "neo-website",
    components: {
        "neo-info": Info,
        "neo-input": Input,
        "neo-restore-btn": RestoreBtn,
        "neo-button": Button,
        "neo-set-status": SetStatus,
        "neo-categorized": Categorized,
        "neo-ext-link": ExtLink,
    },
    props: ["status", "content", "setStatus", "restore", "tab"],
    data() {
        return {
            controls: {
                status: this.content.status,
            },
            tempHolder: "",
        };
    },
    computed: {
        ...mapGetters(["getReadOnlyMode"]),
        website() {
            return this.content.website
                .match(/:\/\/(.[^/]+)/)[1]
                .replace(".com", "")
                .replace("www.", "");
        },
        updateDoc() {
            return {
                case_id: this.$store.getters.getCaseId,
                url: this.content.website,
                id: this.content._id,
                is_collapse: this.content.is_collapse || false,
            };
        },
    },
    mounted() {
        this.website;
    },
    methods: {
        popIrrelevantData() {
            delete this.content.confidence_score;
            this.$emit("dataChanges", {...this.content, status: null, tab: this.tab});
        },
        getEntityIcon(identifier) {
            let icondata = this.$store.getters.getIconsData.filter((elem) => elem.key == identifier);
            if (icondata.length > 0) return icondata[0].icon_data;
            else return require("@/assets/icons/documents.svg");
        },
        onStatChanges(status) {
            this.$emit("dataChanges", {...this.content, status});
        },
        startEdit() {
            this.content.editMode = true;
            this.tempHolder = this.content.website;
        },
        cancelSave() {
            this.content.editMode = false;
            this.content.website = this.tempHolder;
        },
        completeSave() {
            axios.put(`/add-website`, this.updateDoc).then((response) => {});
            this.content.editMode = false;
        },
    },
};
